import "./erp-procurement-and-supply-chain.css";
import { useNavigate } from "react-router-dom";
import useLocalizedPath from "../../../components/use-localized-path";
import Timeline from "../../../components/timeline/timeline-comp";
import { useTranslation } from "react-i18next";

export default function ErpProcurementAndSupplyChain() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const localize = useLocalizedPath();
  const goToContact = () => {
    navigate(localize("/contact-us"));
  };

  const goToAbout = () => {
    navigate(localize("/about-us"));
  };

  const timelineData = [
    {
      date: "01",
      title: "Unified Operations",
      content:
        "Streamlined operations with a single platform for all departments.",
    },
    {
      date: "02",
      title: "Process Automation",
      content:
        "Enhanced productivity and efficiency through automated workflows.",
    },
    {
      date: "03",
      title: "Financial Visibility",
      content: "Track sales and revenue for smarter financial management.",
    },
    {
      date: "04",
      title: "Scalable Growth",
      content:
        "Adaptable systems that evolve with business needs for a competitive edge.",
    },
    {
      date: "05",
      title: "Proactive Support",
      content: "Informed decision-making powered by centralized data insights.",
    },
  ];

  const challenges = [
    {
      number: "01",
      text: "Fragmented systems, manual processes, and disconnected departments create inefficiencies.",
    },
    {
      number: "02",
      text: "Poor communication and missed opportunities hinder productivity and growth.",
    },
    {
      number: "03",
      text: "Lack of integrated solutions prevents organizations from reaching their potential.",
    },
  ];

  const cards = [
    {
      icon: "fa-solid fa-plug", // Represents connection & system integration
      title: "ERP Integration Excellence",
      text: "Specialized in integrating ERP, CRM, PLM, and logistics systems.",
    },
    {
      icon: "fa-solid fa-network-wired", // Represents connectivity and unified systems
      title: "Unified Business Connectivity Platform",
      text: "Unified platform connecting all aspects of your business.",
    },
    {
      icon: "fa-solid fa-cart-shopping", // Represents procurement and business solutions
      title: "Tailored Procurement Solutions",
      text: "Thorough analysis, identifying gaps, and developing tailored solutions.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section erp-main-section">
        <div className="main-image-dark-effect">
          <p className="sub-container-sub-heading">{t("Services")}</p>
          <h1 className="sub-container-heading">
            {t("ERP, Procurement & Supply Chain")}
          </h1>
          <p className="sub-container-desc">
            {t("ERP, Procurement, and Supply Chain solutions streamline core business processes, optimize resources, and enhance transparency to improve efficiency and enable smarter operational decisions.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h2 className="sub-container-heading">{t("Service Overview")}</h2>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/erp-service-overview.webp"
                alt={t("ERP Service Overview")}
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Our ERP, Procurement, and Supply Chain solutions streamline operations, enhance visibility, and improve decision-making. We help organizations optimize resources, reduce costs, and achieve seamless coordination from procurement to delivery for greater efficiency and growth.")}
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Integrated suite of ERP, PLM, and logistics services to streamline operations.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Solutions to optimize customer relationships, supply chains, and product lifecycles.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Enhanced customer engagement, improved supply chain management, and streamlined processes.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
          {t("Common ERP, procurement, and supply chain challenges organizations face in today’s digital landscape.")}
        </p>
        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h2 className="sub-container-heading">{t("How Are We Solving")}</h2>
          <p className="sub-container-desc">
            {t("We combine strategic insight, technical expertise, and collaboration to deliver ERP, procurement, and supply chain solutions that enhance performance, ensure reliability, and drive business efficiency through continuous optimization and innovation.")}
          </p>
          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h2 className="sub-container-heading">{t("Benefits")}</h2>
        <p className="sub-container-desc">
          {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
